<navbar></navbar>
<div class="container bg-white">
    <qst-title></qst-title>
    <qst-score #score></qst-score>
    <qst-quest-items *ngFor="let i of questSections" sectionId={{i}} (scoreChanged)="updateCurrentScore($event)"></qst-quest-items>


